
export default localStorage;
